.container {
  background-color: #212121;
  position: relative;
  /* height: 90vh; */
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: row;
}

.dialog {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 14px;
  font-weight: 300;
}

.dialogContents {
  font-size: 12px;
  font-weight: lighter;
}
